import * as React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { isNotEmpty, NumFormatter } from '../../../utils/format';



function ReqInfoCard({ i }) {
  return (
    <Stack width={"100%"} position={"relative"}>
      <Stack direction={"row"} alignItems={"center"} >
        <Stack gap={1} width={"60%"} alignItems={"start"}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, ml: 2, textAlign: "start" }} >{i?.prodName}</Typography>

          <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"} >
            <Typography fontSize={11} fontWeight={600} width={"35%"}>
              <Box component="span" color={"rgb(0,0,0,0.6)"}>AMTC Ref ID</Box> - {i?.amtcProdIdStrg}
            </Typography>
            <Typography variant="body1" fontSize={11} fontWeight={600} width={"35%"}>
              <Box component="span" fontWeight="500" color={"rgb(0,0,0,0.4)"}>MAT CODE</Box> - {i?.comProdIdStrg}
            </Typography>


          </Stack>
        </Stack>
        <Divider orientation="vertical" flexItem />
        <Stack gap={1} height={"100%"} justifyContent={"center"} width={"20%"}>
          <Stack direction={"row"} alignItems={"center"} >
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 80, color: "rgb(0,0,0,0.4)" }}> Agreed Price (OMR)</Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, ml: 1 }}> {isNotEmpty(i?.AgreedPrice) ? NumFormatter(i?.AgreedPrice) : "NA"} </Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} >
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 80, color: "rgb(0,0,0,0.4)" }}> Tax (%)</Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, ml: 1 }}> {isNotEmpty(i?.comProdTax) ? NumFormatter(i?.comProdTax) : "NA"}</Typography>
          </Stack>
        </Stack>
        <Divider orientation="vertical" flexItem />
        <Stack gap={1} height={"100%"} justifyContent={"center"}>
          <Stack direction={"row"} alignItems={"center"} >
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 80, color: "rgb(0,0,0,0.4)" }}> Agreed Qty </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, ml: 1 }}>    {isNotEmpty(i?.agreedQty) ? `${i?.agreedQty} Nos` : "NA"}    </Typography>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} >
            <Typography sx={{ fontSize: 11, fontWeight: 600, width: 80, color: "rgb(0,0,0,0.4)" }}> Added Qty </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, color: "rgb(0,0,0,0.4)" }}>: </Typography>
            <Typography sx={{ fontSize: 11, fontWeight: 600, ml: 1 }}> {isNotEmpty(i?.qty) ? `${i?.qty} Nos` : "NA"}  </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default ReqInfoCard;